import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import MetricsSection from '../MetricsSection'
import MetricsSectionSkeleton from '../MetricsSection/Skeleton'

import { selectedFacebookAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { clearGetCustomConversions, getCustomConversions } from '../../../../../../modules/actions/choices'
import {
  customConversionsSelector,
  customConversionsWasLoadedSelector,
  getCustomConversionsErrorSelector,
  getCustomConversionsIsLoadingSelector
} from '../../../../../../modules/selectors/choices'

import { CUSTOM_CONVERSIONS } from '../../fields'

const title = 'Custom Conversions Metrics'
const CustomConversionsMetricsSection = ({ formik }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { id: facebookAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const customConversions = useSelector(customConversionsSelector)
  const customConversionsWasLoaded = useSelector(customConversionsWasLoadedSelector)
  const getCustomConversionsError = useSelector(getCustomConversionsErrorSelector)
  const getCustomConversionsIsLoading = useSelector(getCustomConversionsIsLoadingSelector)

  useEffect(() => {
    dispatch(getCustomConversions({ account: facebookAdAccountId }))
  }, [dispatch, facebookAdAccountId])

  useEffect(() => {
    return () => {
      dispatch(clearGetCustomConversions())
    }
  }, [dispatch])

  const formattedCustomConversionsMetrics = useMemo(() => {
    return customConversions?.map(customConversion => ({
      value: customConversion.id,
      label: customConversion.name
    }))
  }, [customConversions])

  const isConversionsWasLoaded = customConversionsWasLoaded || getCustomConversionsError
  const noConversionsMetrics = isConversionsWasLoaded && formattedCustomConversionsMetrics?.length === 0

  if (getCustomConversionsIsLoading) {
    return <MetricsSectionSkeleton title={t(title)} />
  } else if (noConversionsMetrics) {
    // hide a section completely if there are no options
    return null
  }

  return (
    <MetricsSection
      title={t(title)}
      metricsGroupName={CUSTOM_CONVERSIONS}
      metrics={formattedCustomConversionsMetrics}
      formik={formik}
      isCustomMetric={true}
    />
  )
}

export default CustomConversionsMetricsSection
